export function shouldHandleSearchNavigation(event) {
    if (!event) return false;
    if (event.isComposing || event.keyCode === 229) return false;
    return ['ArrowDown', 'ArrowUp', 'Enter', 'Escape'].includes(event.key);
}

export function getNextSearchActiveIndex(currentIndex, total, key) {
    if (total <= 0) return -1;
    if (key === 'ArrowDown') {
        return currentIndex < total - 1 ? currentIndex + 1 : 0;
    }
    if (key === 'ArrowUp') {
        return currentIndex > 0 ? currentIndex - 1 : total - 1;
    }
    return currentIndex;
}

export function getSearchEnterIndex(activeIndex, total) {
    if (total <= 0) return -1;
    if (activeIndex >= 0 && activeIndex < total) return activeIndex;
    return 0;
}
